module.exports = __webpack_public_path__ + "img/pic_ChiayiCity.48caac04.jpg";